
import initCustomScrollbar from "../modules/init-custom-scrollbar.js";
import { isMobile } from "../utils/is-mobile.js";

const initBlock = async function( block ) {
	const $slider = block.find( "[data-testimonials-slider]" );

	if ( !$slider.length ) {return;}

	const { Swiper } = await import( "swiper" );
	const { Pagination, Navigation } = await import( "swiper/modules" );
	await import( "../plugins/scrollbar.min.js" );
	await import( "swiper/css" );
	await import( "swiper/css/pagination" );

	new Swiper( $slider[0], {
		modules: [Pagination, Navigation],
		slidesPerView: "auto",
		slidesPerGroup: 1,
		allowTouchMove: isMobile(),
		spaceBetween: 20,
		navigation: {
			prevEl: block.find( "[data-prev-el]" )[0],
			nextEl: block.find( "[data-next-el]" )[0],
		},
		pagination: {
			el: block.find( "[data-slider-pagination]" )[0],
			type: "fraction"
		},
	} );

	initCustomScrollbar( block );
};

themeUtils.loadBlock( initBlock, "testimonials", ".section-testimonials" );
